import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModuleService } from './module.service';
import { EMPTY } from '@utils';
import { IModule, IErrorResponse } from '@interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { ExceptionService } from '@base/exceptions.service';
import { ICompany } from '@company/company.structures';
import { Subscription, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.sass']
})
export class ModuleComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  currentModule: Observable<IModule>;
  currentCompany: Observable<ICompany>;
  fetchingData: boolean;

  constructor(
    private moduleService: ModuleService,
    private router: Router,
  ) {
    this.subscriptions = [];
    this.fetchingData = false;
    this.currentModule = this.moduleService.observeCurrentModule();
    this.currentCompany = this.moduleService.observeCurrentCompany();

    const fetchingSubscription = this.moduleService.observeFetchingData().subscribe(
      (fetching: boolean) => this.fetchingData = fetching
    );

    this.subscriptions = [...this.subscriptions, fetchingSubscription];
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.subscriptions.map((s: Subscription) => s.unsubscribe());
  }

  rootModule() {
    this.moduleService.setCompany(null);
    const fullParams = String(this.router.url).split('/');
    const targetUrl = fullParams.slice(1, 3).join('/');
    const moduleId = fullParams[3];
    this.router.navigate([targetUrl, moduleId]);
  }
}
